import { IHttpClient } from "../../../lib/http";

export async function getPropertyConfiguration(
  middlewareHttpClient: IHttpClient,
  propertyTicker: string,
  properties: string[]
): Promise<Record<string, any>> {
  const url = `/WitBookerAPI-war/webresources/endpoint/establishment/${propertyTicker}/configurations`;
  const params = new URLSearchParams();
  properties.forEach(it => params.append("prop", it));
  return await middlewareHttpClient.get<Record<string, any>>(`${url}?${params.toString()}`);
}
export async function storePropertyConfiguration(
  middlewareHttpClient: IHttpClient,
  propertyTicker: string,
  propertyMap: Record<string, any>
): Promise<string> {
  const url = `/WitBookerAPI-war/webresources/endpoint/establishment/${propertyTicker}/createOrUpdateConfigurations`;
  return await middlewareHttpClient.post<Record<string, string>, string>(url, propertyMap, {});
}
